/**
 * The briefing list's failed-read state.
 *
 * It used to print `error.message` straight through, which on the appliance
 * meant the reader saw
 * `Failed to load briefings: [use-briefing] PostgREST error: Error: Supabase
 * is not configured in this deployment.` — an internal module tag, a library
 * name and a nested `Error:` prefix, none of which they can act on.
 *
 * The failure is still stated, but backend implementation details are not
 * rendered into the product UI. Operational diagnosis belongs in server-side
 * logs and telemetry rather than in a workspace screen.
 */

import { useStudioLocale } from '@/i18n/use-studio-locale'

export function BriefingLoadError(_props: { error: Error }) {
  const { strings } = useStudioLocale()
  return (
    <div
      data-testid="briefing-list-error"
      className="p-4 text-sm text-destructive"
    >
      <p>{strings.designSystem.validatorPanel.briefingReadFailed}</p>
    </div>
  )
}
